module.exports = __webpack_public_path__ + "img/Mobile_Home_22.cff23202.png";